module.exports = __webpack_public_path__ + "static/googleStoreImage-7a60f99f226d23490bbe9c28613e2635.png";